import eventPolyfill from '../../../00-base/global/utils/event-polyfill';

/**
 * [initCombobox description]
 * @return {[type]} [description]
 */
function initDropdowns(context) {


}


/**
 * Returns the value of the select input.  Assumes the select has
 * js-dqpl-select class.
 * @param {[DOMElement]} select 
 */
export function getDropdownValue(select) {
  return select.value;
}


/**
 * Manually updates the custom select values.
 * @param {[DOMElement]} select 
 * @param {String} value 
 */
export function setDropdownValue(select, value) {
  select.value = parseInt(value);
}

export default initDropdowns;